module.exports = __webpack_public_path__ + "static/media/_BID5525.498b56b3.png";